module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.missionSlotDetails.orderNumber))]), _vm._v(" "), _c('td', [(!_vm.missionSlotDetails.reserve && !_vm.missionSlotDetails.blocked) ? _c('div', [_c('i', {
    class: _vm.difficultyIcon,
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.missionSlotDetails.title) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.missionSlotDetails.reserve || _vm.missionSlotDetails.blocked) ? _c('b-popover', {
    attrs: {
      "content": _vm.titlePopoverContent,
      "triggers": ['hover']
    }
  }, [_c('span', {
    class: _vm.titleColor,
    domProps: {
      "innerHTML": _vm._s(_vm.formattedTitle)
    }
  })]) : _vm._e()], 1), _vm._v(" "), (_vm.hasAnyMissionSlotDescription) ? _c('td', [_vm._v(_vm._s(_vm.missionSlotDetails.description))]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "btn-group btn-group-sm",
    attrs: {
      "role": "group",
      "aria-label": "Mission slot template slot actions"
    }
  }, [_c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionSlotTemplateSlotDetailsModal",
      modifiers: {
        "missionSlotTemplateSlotDetailsModal": true
      }
    }],
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.prepareMissionSlotTemplateSlotDetails
    }
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.details')) + "\n      ")]), _vm._v(" "), (_vm.isMissionSlotTemplateCreator) ? _c('click-confirm', {
    attrs: {
      "yes-icon": "fa fa-trash",
      "yes-class": "btn btn-danger",
      "button-size": "sm",
      "messages": {
        title: _vm.$t('mission.slot.confirm.delete'),
        yes: _vm.$t('button.confirm'),
        no: _vm.$t('button.cancel')
      }
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "danger",
      "size": "sm"
    },
    on: {
      "click": _vm.deleteMissionSlotTemplateMissionSlot
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.delete')) + "\n        ")])], 1) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5587e720"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missionSlotTemplates/MissionSlotTemplateSlotlistGroupSlotsRow.vue
// module id = 524
// module chunks = 0